import src from "IMAGE";
export default { src, width: 299, height: 80, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAMePjoERXx3Ahw3LwQhT0EEIU9CBCJRQgQhTkIEIU1BAAY9gHkFMmllAxc0LAUkVUcFJllKBSdaSgMULicBCBIPkFELmgCezlUAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
